// extracted by mini-css-extract-plugin
export default {"button":"styles_button__PDlCT","primary":"styles_primary__4liPn","tray":"styles_tray__WJtcC","slide-in-bottom":"styles_slide-in-bottom__7Rfxk"};